import { iconHandoff as iconHandoffStringsZhTW } from './icon-handoff-zh-TW';

const zhTW = {
    translation: {
        // Toolbar - Category Rail
        toolbarCategoryDrawing: '繪製工具',
        toolbarCategoryTrains: '列車管理',
        toolbarCategoryInfra: '基礎設施 & 顯示',
        toolbarCategoryScene: '場景 & 檔案',
        toolbarCategoryDebug: '除錯 & 檢視',

        // Toolbar - Layout
        startLayout: '開始佈軌',
        endLayout: '結束佈軌',
        deleteTrack: '刪除軌道',
        endDeletion: '結束刪除',
        duplicateTrackToSide: '複製軌道到側邊',
        catenaryLayout: '架線佈置',
        jointDirection: '道岔方向',

        // Toolbar - Mode Exit Chip
        exitMode: '結束',
        modeDrawingLayout: '佈軌中',
        modeDeletingTrack: '刪除軌道中',
        modePlacingTrain: '放置列車中',
        modePlacingStation: '放置車站中',
        modeDuplicatingTrack: '複製軌道中',
        modeCatenaryLayout: '架線佈置中',
        modeSingleSpinePlatform: '單側月台佈置中',
        modeDualSpinePlatform: '雙側月台佈置中',
        modePlacingBuilding: '放置建築中',
        modeDeletingBuilding: '刪除建築中',
        modeJointDirection: '道岔方向',

        // Toolbar - Train
        placeTrain: '放置列車',
        endPlacement: '結束放置',
        trainList: '列車清單',
        closeTrainList: '關閉列車清單',
        openDepot: '開啟車庫',
        closeDepot: '關閉車庫',
        editFormations: '編輯編組',
        closeFormations: '關閉編組',

        // Toolbar - Building
        placeBuilding: '放置建築',
        deleteBuilding: '刪除建築',

        // Toolbar - Station
        placeStation: '放置車站',
        endStationPlacement: '結束放置車站',
        openStationList: '開啟車站清單',
        closeStationList: '關閉車站清單',

        // Toolbar - Visualization
        showElevationGradient: '顯示高度漸層',
        hideElevationGradient: '隱藏高度漸層',
        showPreviewCurveArcs: '顯示預覽曲線弧',
        hidePreviewCurveArcs: '隱藏預覽曲線弧',
        elevationGradientLabel: '高度漸層',
        curveArcsLabel: '曲線弧',
        mapLabel: '地圖',
        importExport: '匯入 / 匯出',
        showMap: '顯示地圖',
        hideMap: '隱藏地圖',
        openDebug: '開啟除錯選項',
        closeDebug: '關閉除錯選項',
        sunAngle: '日照角度',
        terrainFill: '地形',
        terrainOpacity: '地形透明度',
        whiteOcclusion: '白色遮罩',
        elevation: '高度',

        // Export/Import
        exportTracksStations: '匯出軌道 + 車站',
        importTracksStations: '匯入軌道 + 車站',
        exportTrains: '匯出列車（車輛、編組、位置）',
        importTrains: '匯入列車',
        exportAll: '匯出全部（軌道 + 列車 + 車站 + 時刻表）',
        importAll: '匯入全部（軌道 + 列車 + 車站 + 時刻表）',
        importTerrain: '匯入地形',
        invalidTerrainData: '無效的地形資料：{{error}}',
        importCarDefinitionFromEditor: '匯入車輛定義（從列車編輯器）',
        importCarDefinitionFromLibrary: '匯入車輛定義（從程式庫）',

        // Scene Management
        sceneNotFound: '在儲存空間中找不到場景',
        sceneDataInvalid: '場景資料無效：{{error}}',
        sceneLoaded: '已載入「{{name}}」',
        sceneRestoreFailed: '還原場景失敗',
        scenePickerTitle: '已儲存的場景',
        scenePickerDescription: '選擇一個場景繼續，或建立新場景。',
        newScene: '新場景',
        saveScene: '儲存場景',
        savedScenes: '已儲存的場景',
        noSavedScenes: '尚未儲存任何場景。',
        lastActive: '上次使用',
        justNow: '剛剛',
        minutesAgo: '{{count}}分鐘前',
        hoursAgo: '{{count}}小時前',
        daysAgo: '{{count}}天前',
        confirmDelete: '刪除',
        autoSaveInterval: '自動儲存間隔',
        autoSave1Min: '1 分鐘',
        autoSave3Min: '3 分鐘',
        autoSave5Min: '5 分鐘',
        autoSave10Min: '10 分鐘',
        autoSaveToast: '「{{name}}」已自動儲存',

        // Track-aligned platform hints
        hintPickStart: '點擊軌道設定起點',
        hintPickEnd: '沿軌道點擊設定終點',
        hintDrawOuter: '點擊繪製月台邊緣 — 靠近起點錨點以完成',
        hintDualPickSpineAStart: '點擊軌道設定脊線 A 起點',
        hintDualPickSpineAEnd: '沿軌道點擊設定脊線 A 終點',
        hintDualPickSpineBStart: '點擊對面軌道設定脊線 B 起點',
        hintDualPickSpineBEnd: '沿軌道點擊設定脊線 B 終點',
        hintDualDrawCap1: '點擊繪製第一個端蓋 — 靠近吸附環以完成',
        hintDualDrawCap2: '點擊繪製第二個端蓋 — 靠近吸附環以完成',
        hintPlatformCreated: '月台已建立',

        // Validation errors
        invalidTrackData: '無效的軌道資料：{{error}}',
        invalidTrainData: '無效的列車資料：{{error}}',
        invalidSceneData: '無效的場景資料：{{error}}',
        invalidCarDefinition: '無效的車輛定義：{{error}}',

        // Train Panel
        trains: '列車',
        placedTrains: '已放置的列車',
        car_one: '{{count}} 節車廂',
        car_other: '{{count}} 節車廂',
        controls: '控制',
        throttleP5: '動力 P5',
        neutral: '空檔',
        switchDirection: '切換方向',
        removeSelectedTrain: '移除選取的列車',
        atStation: '位於：{{name}}',
        focusOnSelectedTrain: '聚焦選取的列車',
        followSelectedTrain: '跟隨選取的列車',
        stopFollowing: '停止跟隨',

        // Depot Panel
        depot: '車庫',
        noCarsInStock: '車庫中沒有車輛',
        bogieCount: '{{count}} 個轉向架',
        carTemplates: '車廂樣板',
        formationTemplates: '編組樣板',
        newFormationTemplate: '新編組樣板',
        noFormationTemplates: '尚無編組樣板',
        slot_one: '{{count}} 節',
        slot_other: '{{count}} 節',
        missingCarTemplates_one: '缺少 {{count}} 個樣板',
        missingCarTemplates_other: '缺少 {{count}} 個樣板',
        unknownCarTemplate: '未知（{{id}}）',
        addSlot: '新增節',
        materializeFormation: '建立編組',
        cannotMaterializeMissing: '請先處理缺少的車廂樣板',
        addSlotNoCarTemplates: '請先建立車廂樣板',
        pickReplacementCarTemplate: '選擇替代車廂樣板…',
        editSlots: '編輯節',
        flipCar: '翻轉車廂方向',
        carType: '類型',
        carType_locomotive: '機車',
        carType_coach: '客車',
        carType_motor: '動力車',
        carType_trailer: '拖車',
        carType_freight: '貨車',
        carType_cab_car: '駕駛車',

        // Station List Panel
        stations: '車站',
        createEmptyStation: '建立空車站',
        noStations: '沒有車站',
        platform_one: '{{count}} 個月台',
        platform_other: '{{count}} 個月台',
        donePickingPlatforms: '完成選取月台',
        pickPlatformsToAdd: '選取要加入的月台',
        panToStation: '移至車站',
        deleteStation: '刪除車站',
        addSingleSpinePlatform: '新增單側月台',
        addDualSpinePlatform: '新增雙側月台',
        trackAlignedPlatform_one: '{{count}}個軌道月台',
        trackAlignedPlatform_other: '{{count}}個軌道月台',
        nearbyPlatforms: '附近月台',
        cancel: '取消',
        noNearbyPlatforms: '附近沒有其他車站的月台',
        platformTrackInfo: '月台 {{platformId}} — 軌道 {{trackId}}',
        fromStationDistance: '來自 {{name}} · {{distance}}m',
        stationFallback: '車站 {{id}}',

        // Formation Selector
        formation: '編組',
        defaultFormation: '預設（4 節車廂）',

        // Track Style Selector
        trackStyle: '軌道樣式',
        ballasted: '碎石道床',
        slabElevated: '板式（高架）',
        electrified: '電氣化',
        bed: '路基',
        bedWidth: '路基寬度',
        snapBuffer: '吸附距離',
        trackGauge: '軌距',
        customGauge: '自訂',
        gaugeLabels: '軌距標籤',

        // Building Options Panel
        building: '建築',
        small: '小',
        medium: '中',
        large: '大',
        lShape: 'L 型',
        ground: '地面',
        above1: '地上 1',
        above2: '地上 2',
        above3: '地上 3',
        height: '高度',
        level: '層',

        // Debug Panel
        debug: '除錯',
        jointNumbers: '接頭編號',
        segmentIds: '區段 ID',
        formationIds: '編組 ID',
        stationStops: '停靠站',
        stationLocations: '車站位置',
        showBogies: '轉向架',
        terrainXray: '地形透視',
        fpsStats: 'FPS 統計',

        // Train Editor
        editBogies: '編輯轉向架',
        endEdit: '結束編輯',
        addBogie: '新增轉向架',
        endAdd: '結束新增',
        removeBogie: '移除轉向架',
        endRemove: '結束移除',
        importImage: '匯入圖片',
        editImage: '編輯圖片',
        endImageEdit: '結束圖片編輯',
        cropImage: '裁切圖片',
        endCrop: '結束裁切',
        confirmCrop: '確認裁切',
        cancelCrop: '取消裁切',
        carWidth: '車身寬度（公尺）',
        exportCarDefinition: '匯出車輛定義',
        importCarDefinition: '匯入車輛定義',
        saveToLibrary: '儲存到程式庫',
        loadFromLibrary: '從程式庫載入',
        save: '儲存',
        carDefinitionLibraryTitle: '車輛定義程式庫',
        carDefinitionLibraryDescription: '選擇要載入的已儲存車輛定義。',
        noSavedCarDefinitions: '尚未儲存任何車輛定義。',
        carDefinitionNamePlaceholder: '車輛名稱',
        saveCarDefinitionTitle: '儲存車輛定義',
        saveCarDefinitionDescription: '為此車輛命名以儲存到程式庫。',
        saveCarDefinitionUpdateTitle: '更新車輛定義',
        saveCarDefinitionUpdateDescription: '更新現有項目或重新命名。',
        untitledCar: '未命名車輛 {{count}}',
        needAtLeast2Bogies: '需要至少 2 個轉向架才能匯出。',
        failedToParseJson: '解析 JSON 失敗：{{error}}',
        invalidFileMissingBogieOffsets: '無效的檔案：缺少 bogieOffsets。',

        // Signal Panel
        signals: '號誌',
        openSignals: '號誌',
        closeSignals: '關閉號誌',
        addSignal: '新增號誌',
        segmentNumber: '區段編號',
        signalsList: '號誌',
        addBlock: '新增閉塞區間',
        entrySignal: '入口號誌 ID',
        exitSignal: '出口號誌 ID',
        autoFillAndCreate: '自動填入並建立',
        preview: '預覽',
        previewAutoFillTooltip: '預覽自動填入的區段，不建立',
        enterValidSignalIds: '請輸入有效的號誌 ID',
        noPathBetweenSignals: '號誌之間找不到路徑',
        manualSegments: '手動輸入區段',
        blocksList: '閉塞區間',

        // Timetable Panel
        timetable: '時刻表',
        openTimetable: '開啟時刻表',
        closeTimetable: '關閉時刻表',
        routes: '路線',
        noRoutes: '尚未定義路線',
        addRoute: '新增路線',
        routeName: '路線名稱',
        jointSequence: '接頭編號（以逗號分隔）',
        shifts: '班次',
        noShifts: '尚無班次範本',
        addShift: '新增班次',
        shiftName: '班次名稱',
        stops: '停靠站',
        stationPlaceholder: '車站...',
        arrivalTime: '到 HH:MM',
        departureTime: '發 HH:MM',
        platformPlaceholder: '月台...',
        stopPositionPlaceholder: '停車位置...',

        // Platform Editor Panel
        platformEditor: '月台編輯',
        stopPositions: '停車位置',
        addStopPosition: '+ 停車位置',
        deleteStopPosition: '刪除',
        directionTangent: '→',
        directionReverseTangent: '←',
        position: '位置',
        noStopPositions: '沒有停車位置',
        confirmDeleteStopTitle: '刪除停車位置？',
        confirmDeleteStopMessage:
            '此停車位置被 {{count}} 個班次引用：{{shifts}}。刪除後會使這些班次的引用失效。',
        confirmDeleteStopConfirm: '仍然刪除',
        confirmDeleteStopCancel: '取消',
        routePlaceholder: '路線...',
        addStop: '+ 停靠站',
        assignments: '指派',
        noAssignments: '尚無指派',
        assignShift: '指派班次',
        selectFormation: '選擇編組',
        selectShift: '選擇班次',
        suspended: '暫停',
        activeDrivers: '運行中的駕駛',
        noActiveDrivers: '沒有運行中的駕駛',
        stopCount: '{{count}} 個停靠站',
        jointCount: '{{count}} 個接頭',
        removeRoute: '移除路線',
        removeShift: '移除班次',
        removeAssignment: '移除指派',
        exportTimetable: '匯出時刻表',
        importTimetable: '匯入時刻表',
        invalidTimetableData: '無效的時刻表資料：{{error}}',

        // Resource Types
        'resource.passenger': '乘客',
        'resource.ironOre': '鐵礦',
        'resource.goods': '貨物',

        // Resource Panel (on train)
        'panel.resources.title': '載貨',
        'panel.resources.capacity': '容量',
        'panel.resources.empty': '空載',
        'panel.resources.transferring': '搬運中…',

        // Platform Resource Panel
        'panel.platform.resources.title': '資源',
        'panel.platform.resources.bufferShared': '與車站共用緩衝',
        'panel.platform.resources.role': '角色',
        'panel.platform.resources.roleSource': '產出',
        'panel.platform.resources.roleSink': '消耗',
        'panel.platform.resources.roleNeither': '—',

        // Formation Editor
        formations: '編組',
        onTrack: '在軌道上',
        inDepot: '在車庫中',
        noFormationsInDepot: '車庫中沒有編組。',
        clickPlusToCreate: '按下 + 建立一個。',
        addCarsToDepotFirst: '請先將車輛加入車庫。',
        trainLabel: '列車 {{number}}',
        couplable: '可連結',
        couple: '連結',
        coupleWith: '與列車{{number}}連結',
        couplingDepthExceeded: '無法連結：編組巢狀過深，請先整合其中一個編組。',
        couplingAutoSuccess: '列車已連結',
        proximityLines: '連結近接顯示',
        nested: '巢狀',
        containsNestedFormations: '包含巢狀編組',
        nestedFormation: '巢狀編組',
        composition: '組成',
        consolidate: '合併',
        consolidateTooltip: '將巢狀編組扁平展開為個別車輛',
        reverseTooltip: '反轉子車輛順序',
        reverseNestedTooltip: '反轉此編組的子車輛順序',
        flipChildDirectionTooltip: '翻轉此子車輛的方向',
        renameFormation: '點擊以重新命名',
        renameCar: '點擊以重新命名',
        addFromStock: '從車庫加入',
        addFormation: '加入編組',

        // Landing Page
        nextStop: '下一站',
        landingTagline1: '直接在瀏覽器裡面就能使用的 2D 俯視角鐵道模擬器。',
        landingTagline2: '軌道、車站、列車、自由組合',
        openSimulator: '開啟模擬器',
        openTutorial: '教學（製作中）',
        openCarEditor: '開啟車輛編輯器',
        build: '建造',
        simulate: '模擬',
        featureTrackDrawing: '高度自由的佈軌系統',
        featureTerrain: '平面但不扁平，分層的高度系統，想要地下鐵？沒問題！',
        featureStations: '車站與建築（施工中）',
        featureTrainSim: '列車運行模擬，想要親自駕駛列車也 Ok!',
        featureFormations: '靈活的列車編組',
        featureNavigation: '平滑導覽',
        featureImportExport: '匯入與匯出，雲端與瀏覽器端自動儲存開發中',
        featureDynamicFormations:
            '直接模擬聯掛與解聯，PP 在苗栗臨時要掛補機？沒問題，不過你確定要嗎？（施工中）',
        featureGranularity: '細粒度的時刻表編排（施工中）',
        builtWithFooter:
            '基於 <ueToo>ue-too</ueToo> 打造 · <issues>回饋，或是想要的 feature 可以提 issue</issues>',
        cjkFontCreditFooter:
            'CJK 點陣字型：<cubic11>Cubic 11</cubic11> by ACh-K',
        motionOn: '動態效果：開',
        motionOff: '動態效果：關',
        enableAnimations: '啟用動畫',
        reduceAnimations: '減少動畫',

        // Analytics Notice
        analyticsNotice:
            '本網站僅使用基本事件追蹤來改善使用體驗，不會收集任何個人資料。',

        // 404 Page
        notFoundMessage: '這條軌道不通往任何地方。',
        backToHome: '首頁',

        // Icon handoff (/icon-handoff)
        iconHandoff: iconHandoffStringsZhTW,
    },
} as const;

export default zhTW;
